module.exports = __webpack_public_path__ + "assets/img/avatar.0fbc6b29.png";